import { FC } from 'react';

import { ShareChannel } from '@shared/api/giftCoupon/giftCoupon.interface';
import { GiftDeliveryShareChannel } from '@shared/api/giftDelivery/giftDelivery.interface';
import { Icon } from '@shared/components/icons';

interface Props {
  channel?: ShareChannel | GiftDeliveryShareChannel | null;
  className?: string;
}

const CHANNEL_TITLE: Record<string, string> = {
  KakaoTalk: '마지막 공유: 카카오톡',
  SMS: '마지막 공유: 문자',
  Link: '마지막 공유: 링크 복사',
  Other: '마지막 공유: 다른 앱',
};

/**
 * 마지막으로 공유한 채널을 작은 아이콘으로 표시.
 * 카톡 / SMS / Link / Other 4종을 지원하며, 값이 없으면 아무 것도 렌더하지 않는다.
 */
export const ShareChannelIcon: FC<Props> = ({ channel, className = 'h-3.5 w-3.5' }) => {
  const { ShareKakao, ShareMessage, Link, OtherApps } = Icon();

  if (!channel) return null;

  const title = CHANNEL_TITLE[channel] ?? '마지막 공유 채널';

  switch (channel) {
    case 'KakaoTalk':
      return (
        <span title={title} className="inline-flex flex-shrink-0">
          <ShareKakao className={className} />
        </span>
      );
    case 'SMS':
      return (
        <span title={title} className="inline-flex flex-shrink-0">
          <ShareMessage className={className} />
        </span>
      );
    case 'Link':
      return (
        <span title={title} className="inline-flex flex-shrink-0">
          <Link className={className} />
        </span>
      );
    case 'Other':
      return (
        <span title={title} className="inline-flex flex-shrink-0">
          <OtherApps className={className} />
        </span>
      );
    default:
      return null;
  }
};
